<template>
  <div class="content-wrapper">
    <section class="content-header">
      <div class="container-fluid">
        <div class="row">
          <div class="col-sm-12">
            <h1>
              Device Activation
              <!--              <router-link :to="{ name: 'ProvisionAdd' }" class="btn ml-auto">-->
              <!--                <i class="icon-plus"></i> New-->
              <!--              </router-link>-->
            </h1>
          </div>
          <div class="col-sm-6">
            <ol class="breadcrumb float-sm-right">
              <li class="breadcrumb-item">
                <router-link :to="{ name: 'Home' }">Home</router-link>
              </li>
              <li class="breadcrumb-item active">Users</li>
            </ol>
          </div>
        </div>
      </div>
    </section>
    <section class="content" v-if="has_permission === true">
      <div class="container-fluid">
        <div class="pt-3">
          <div class="card">
            <div
              class="card-header py-3"
              v-if="!_.isEmpty(list.data) && is_loading == false"
            >
              <a
                href="javascript:void(0)"
                class="btn btn-info"
                @click="showFilter = !showFilter"
              >
                <i class="fa fa-filter" :class="showFilter ? 'icon-up' : ''"></i>Filter</a
              >
            </div>

            <div class="overlay" v-if="is_loading">
              <img src="/assets/images/loader.svg" alt="" />
            </div>
            <form @submit.prevent="getFilterData()" method="GET" novalidate>
              <div class="card-body" v-if="showFilter">
                <div class="row">
                  <div class="col-md-3">
                    <div class="form-group">
                      <label class="col-form-label" for="macID">MAC ID</label>
                      <div class="input-group">
                        <div class="input-group-prepend">
                          <span class="input-group-text">
                            <i class="fas fa-pencil-alt"></i>
                          </span>
                        </div>
                        <input
                          autocomplete="off"
                          type="text"
                          id="macID"
                          name="macID"
                          v-model="filter.mac"
                          class="form-control"
                          placeholder="macID"
                        />
                      </div>
                    </div>
                  </div>
                  <div class="col-md-6 form-group">
                    <label class="col-form-label" for="productName">Product</label>
                    <el-select
                      class="w-100"
                      v-model="filter.product_name"
                      placeholder="Select Product"
                      filterable
                      clearable
                      :class="{ 'has-error': errors.has('product_name') }"
                      id="productName"
                      name="product_name"
                    >
                      <el-option
                        v-for="product in pre.allproduct"
                        :key="product.device_type"
                        :label="product.alias + ' (' + product.device_type + ')'"
                        :value="product.device_type"
                      />
                    </el-select>
                  </div>

                  <div class="col-md-4 form-group">
                    <label class="col-form-label" for="status">Activation Status</label>
                    <el-select
                      class="w-100"
                      v-model="filter.activation_status"
                      filterable
                      clearable
                      placeholder="Select status"
                      :class="{ 'has-error': errors.has('status') }"
                      id="status"
                      name="status"
                    >
                      <el-option label="Due Activation" value="Due Activation" />
                      <el-option label="Activated" value="Activated" />
                      <!--                      <el-option label="De-Activated" value="deactivated"/>-->
                    </el-select>
                  </div>

                  <div class="col-md-4 form-group">
                    <label class="col-form-label" for="license_user">License</label>
                    <el-select
                      class="w-100"
                      v-model="filter.license_user"
                      placeholder="Select License User"
                      filterable
                      clearable
                      :class="{ 'has-error': errors.has('license_user') }"
                      id="license_user"
                      name="license_user"
                    >
                      <el-option
                        v-for="licence in pre.license"
                        :key="licence"
                        :label="licence"
                        :value="licence"
                      />
                    </el-select>
                  </div>
                  <div class="col-md-4 form-group">
                    <label class="col-form-label" for="deviceName">Device</label>
                    <el-select
                      class="w-100"
                      v-model="filter.device_type"
                      placeholder="Select Device"
                      filterable
                      clearable
                      :class="{ 'has-error': errors.has('device_name') }"
                      id="deviceName"
                      name="device_name"
                    >
                      <el-option
                        v-for="device in pre.device_name"
                        :key="device"
                        :label="device"
                        :value="device"
                      />
                    </el-select>
                  </div>

                  <!-- Last Row: Date Filters -->
                  <div class="col-md-6 form-group">
                    <label class="col-form-label">Activation Date Range</label>
                    <div class="row">
                      <div class="col-md-6">
                        <el-date-picker
                          v-model="filter.start_time"
                          type="date"
                          placeholder="Start date"
                          id="start_time"
                          name="start_time"
                          format="yyyy-MM-dd"
                          value-format="yyyy-MM-dd 00:00:00"
                          :class="{ 'has-error': errors.has('start_time') }"
                        />
                        <div class="help text-danger" v-show="errors.has('start_time')">
                          {{ errors.first("start_time") }}
                        </div>
                      </div>
                      <div class="col-md-6">
                        <el-date-picker
                          v-model="filter.end_time"
                          type="date"
                          placeholder="End date"
                          id="end_time"
                          name="end_time"
                          format="yyyy-MM-dd"
                          value-format="yyyy-MM-dd 23:59:59"
                          :picker-options="getEndDatePickerOptions()"
                          :class="{ 'has-error': errors.has('end_time') }"
                        />
                        <div class="help text-danger" v-show="errors.has('end_time')">
                          {{ errors.first("end_time") }}
                        </div>
                      </div>
                    </div>
                  </div>
                  <div class="col-md-12 text-right">
                    <button type="submit" class="btn mr-3">
                      <i class="icon-search"></i> Search
                    </button>
                    <button type="reset" class="btn btn-outline" @click="resetFilter()">
                      <i class="icon-refresh"></i> Reset
                    </button>
                  </div>
                </div>
              </div>
            </form>

            <div class="card-body">
              <div v-if="!_.isEmpty(list.data) && is_loading == false">
                <div class="table-responsive">
                  <table class="table">
                    <thead>
                      <tr>
                        <th>Name</th>
                        <th>Email</th>
                        <th>Mac</th>
                        <th>Product</th>
                        <th>Device</th>
                        <th>License</th>
                        <th>Activation Date</th>
                        <th>status</th>
                        <!--<th>Resend Email</th>-->
                        <th class="text-right">View details</th>
                      </tr>
                    </thead>
                    <tbody class="list">
                      <tr v-for="(val, index) in list.data" :key="index">
                        <!-- <td>{{ val.initial_configuration.username}}</td> -->
                        <td>
                          {{ getNameValue(val) }}
                        </td>
                        <td>
                          {{ getEmailValue(val) }}
                        </td>

                        <td>{{ val.mac }}</td>
                        <td>
                          {{ val.application_alias ? val.application_alias.alias : "" }}
                        </td>
                        <td>{{ val.device_type }}</td>
                        <td>{{ val.license_user }}</td>
                        <td>{{ val.account ? val.account.activation_date : "" }}</td>
                        <td style="width: 170px">
                          <el-dropdown>
                            <!-- <div
                          class="d-flex align-items-center status-dropdown-btn"
                        >
                          <span class="select-status bg-secondary"></span>
                          Due Activation
                          <i class="icon-nat"></i>
                        </div> -->
                            <div>
                              <div
                                v-if="val.activation_status == 'Due Activation'"
                                class="d-flex align-items-center status-dropdown-btn"
                              >
                                <span class="select-status bg-secondary"></span>
                                Due Activation
                                <i class="icon-nat"></i>
                              </div>
                              <div
                                v-else-if="val.activation_status == 'Activated'"
                                class="d-flex align-items-center status-dropdown-btn"
                              >
                                <span class="select-status bg-success"></span>
                                Activated
                                <i class="icon-nat"></i>
                              </div>
                              <div
                                v-else-if="val.activation_status == 'De-Activated'"
                                class="d-flex align-items-center status-dropdown-btn"
                              >
                                <span class="select-status bg-danger"></span>
                                De-Activated
                                <i class="icon-nat"></i>
                              </div>
                            </div>

                            <el-dropdown-menu slot="dropdown" class="p-2 status-dropdown">
                              <li
                                v-for="(state_obj, index) in getToStatesList(
                                  val.activation_status
                                )"
                              >
                                <router-link
                                  v-if="state_obj.to_state == 'Activated'"
                                  :to="{ name: 'ProvisionEdit', params: { id: val.id } }"
                                >
                                  <span class="select-status bg-success mr-1"></span>
                                  Activate
                                </router-link>
                                <a
                                  v-else-if="state_obj.to_state == 'De-Activated'"
                                  href="#"
                                  @click.prevent="openModal('deActivated', val)"
                                >
                                  <span class="select-status bg-danger mr-1"></span>
                                  De-Activate
                                </a>
                                <a v-else href="#">
                                  <span class="select-status bg-secondary mr-1"></span>
                                  {{ state_obj.to_state }}
                                </a>
                              </li>

                              <!--                          <li>-->
                              <!--                            <router-link-->
                              <!--                              :to="{-->
                              <!--                                  name: 'ProvisionEdit',-->
                              <!--                                  params: { id: val.id },-->

                              <!--                                }"-->
                              <!--                            >-->
                              <!--                                <span-->
                              <!--                                  class="select-status bg-secondary mr-1"-->
                              <!--                                ></span>-->
                              <!--                              Due Activation-->
                              <!--                            </router-link>-->
                              <!--                          </li>-->
                              <!--                          <li class="my-2">-->
                              <!--                            <a href="">-->
                              <!--                                <span-->
                              <!--                                  class="select-status bg-success mr-1"-->
                              <!--                                ></span>-->
                              <!--                              Activated-->
                              <!--                            </a>-->
                              <!--                          </li>-->
                              <!--                          <li>-->
                              <!--                            <a-->
                              <!--                              href="#"-->
                              <!--                              @click.prevent="openModal('deActivated', val)"-->
                              <!--                            >-->
                              <!--                                <span-->
                              <!--                                  class="select-status bg-danger mr-1"-->
                              <!--                                ></span>-->
                              <!--                              De-Activated-->
                              <!--                            </a>-->
                              <!--                          </li>-->
                            </el-dropdown-menu>
                          </el-dropdown>
                        </td>
                        <!--<th> <td>
                          <a
                            href="#"
                            v-if="val.active_status === 0"
                            @click.prevent="resendActivationEmail(val)"
                          >
                            Send Mail
                          </a>
                        </td> -->
                        <td class="text-right">
                          <router-link
                            :to="{
                              name: 'ProvisionView',
                              params: { id: val.id },
                            }"
                            class="btn btn-view"
                          >
                            <i class="icon-eye"></i>
                          </router-link>
                          <!-- <router-link
                        :to="{
                          name: 'ProvisionEdit',
                          params: { id: val.id },
                        }"
                        class="btn btn-edit"
                      >
                        <i class="icon-edit"></i>
                      </router-link> -->
                          <!-- <a
                        class="btn btn-trash"
                        href="javascript:void(0)"
                        @click="deleteObject(val.id, index)"
                        ><i class="icon-trash"></i
                      ></a> -->
                        </td>
                      </tr>
                    </tbody>
                  </table>
                </div>
                <div class="mt-3 text-right d-block d-sm-none px-3">
                  Swipe <i class="icon-swipe"></i>
                </div>
              </div>
              <div class="p-4" v-if="_.isEmpty(list.data) && is_loading == false">
                <div class="no-data">
                  <img src="/assets/images/no-data.svg" alt="" />
                  <h3>No data found!</h3>
                </div>
              </div>
            </div>
            <div :class="{ 'card-footer': list.total > list.per_page }">
              <vue-pagination
                :pagination="list"
                v-if="list.total > list.per_page"
                @paginate="reload()"
              ></vue-pagination>
            </div>
          </div>
        </div>
      </div>
    </section>

    <section class="content" v-if="has_permission === false">
      <div class="alert alert-danger alert-dismissible">
        <h5><i class="icon fas fa-ban"></i> Permission denied!</h5>
      </div>
    </section>

    <div
      class="modal fade"
      tabindex="-1"
      role="dialog"
      :class="{ show: showModal === 'deActivated' }"
      :style="showModal === 'deActivated' ? 'display: block;' : ''"
      :aria-modal="showModal === 'deActivated' ? 'true' : null"
    >
      <div class="modal-dialog" role="document">
        <div class="modal-content">
          <div class="modal-header">
            <h5 class="modal-title"><i class="icon-alert-triangle"></i> Warning</h5>
            <button type="button" class="close" @click="closeModal" aria-label="Close">
              <i class="icon-close"></i>
            </button>
          </div>
          <form>
            <div class="modal-body">
              <p>
                This action will <strong>de-activate</strong> the user account and their
                Audra device will no longer function. Are you sure you would like to
                complete this action?
              </p>
              <div class="form-group">
                <label class="col-form-label"
                  >Reason For De-Activation <sup class="text-danger">*</sup></label
                >
                <el-select
                  class="w-100"
                  v-model="deprovision.status_reason"
                  placeholder="Select Reason"
                  :class="{ 'has-error': errors.has('status_reason') }"
                  name="status_reason"
                >
                  <el-option
                    v-for="(item, key) in pre.deprovision_reason"
                    :label="key"
                    :value="key"
                    :key="key"
                  />
                </el-select>
              </div>
              <div class="form-group">
                <label class="col-form-label"
                  >Sub-Reason For De-Activation <sup class="text-danger">*</sup></label
                >
                <el-select
                  class="w-100"
                  v-model="deprovision.status_sub_reason"
                  placeholder="Select Reason"
                  :class="{ 'has-error': errors.has('status_sub_reason') }"
                  name="status_sub_reason"
                >
                  <el-option
                    v-for="item in pre.deprovision_sub_reason"
                    :key="item.value"
                    :label="item"
                    :value="item"
                  />
                </el-select>
              </div>
            </div>
            <div class="modal-footer">
              <button type="button" class="btn btn-secondary" @click="closeModal">
                Cancel
              </button>
              <button type="button" class="btn" @click="deviceDeactivate">
                De-Activate
              </button>
            </div>
          </form>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import VuePagination from "@/components/partials/PaginationComponent";
import SortIcons from "@/components/utils/SortIcons";
import { CommonAPI, PermissionChecker } from "@/services/api";
import LocalStorage from "@/services/localStorage";
import axios from "axios";
import { isEmpty } from "lodash";
import DatePicker from "vue2-datepicker";
import "vue2-datepicker/index.css";
import { mapGetters } from "vuex";
// const fileDownload = require("js-file-download");

export default {
  name: "PortForwarding",
  metaInfo: {
    title: "Provision | Dotlines",
  },
  components: {
    DatePicker,
    VuePagination,
    SortIcons,
  },
  data: () => ({
    organizationId: LocalStorage.get("organizationId"),
    userEmail: LocalStorage.get("userEmail"),
    list: {
      total: 0,
      per_page: 1,
      from: 1,
      to: 0,
      current_page: 1,
    },
    actionCreate: true,
    actionView: true,
    actionEdit: true,
    actionDelete: true,
    api_url: "",
    reset_api_url: "",
    provision_list_api_url: "",
    showFilter: false,
    showModal: null,
    // filter:{},
    filter: {
      mac: "",
      product_name: "",
      activation_status: "",
      license_user: "",
      device_type: "",
      start_time: "",
      end_time: "",
    },
    dateRange: "",
    deprovision: {
      status_reason: "",
      status_sub_reason: "",
    },
    pre: {
      audraName: {},
      status: {
        ACTIVE: "ENABLE",
        DISABLED: "DISABLE",
      },
      protocollist: {
        TCP: "TCP",
        UDP: "UDP",
      },
      provision_states_list: [],
      deprovision_reason: {},
      deprovision_sub_reason: [],
      allproduct: [],
      device_name: [],
      license: [],
    },
    is_loading: false,
    empty: false,
    empty_message: "",
    custom_permission_data: [],
    has_permission: true,
    selected_row: [],
    is_selected_all: false,
  }),
  watch: {
    "$route.query"() {
      this.reload();
    },
    "deprovision.status_reason"() {
      console.log("watch deprovision.status_reason", this.deprovision.status_reason);
      if (this.pre.deprovision_reason.hasOwnProperty(this.deprovision.status_reason)) {
        this.pre.deprovision_sub_reason = this.pre.deprovision_reason[
          this.deprovision.status_reason
        ];
      } else {
        this.pre.deprovision_sub_reason = [];
      }
    },
  },
  mounted: function () {
    if (this.isMobile()) {
      window.$(document).find(".push-menu-class").trigger("click");
    }
    this.api_url = "/provisions";
    this.reset_api_url = "/de-provision";
    this.provision_list_api_url = "/provision_state";
    this.initialize();
    this.$root.$on("sort-data", () => {
      this.$root.$emit("show-icon");
      this.reload();
    });
  },
  computed: {
    ...mapGetters(["profile"]),
    computed: {
      endDatePickerOptions() {
        return {
          disabledDate: (date) => {
            if (!this.filter.start_time) return false;
            // Disable all dates before the start date
            const start = new Date(this.filter.start_time);
            // Only compare the date part (ignore time)
            return date.setHours(0, 0, 0, 0) < start.setHours(0, 0, 0, 0);
          },
          disabledTime: (date) => {
            if (!this.filter.start_time) return {};
            const start = new Date(this.filter.start_time);
            // If not the same day, allow all times
            if (date.setHours(0, 0, 0, 0) !== start.setHours(0, 0, 0, 0)) {
              return {};
            }
            // If same day, disable hours/minutes/seconds before start time
            const disabledHours = [];
            for (let i = 0; i < start.getHours(); i++) {
              disabledHours.push(i);
            }
            const disabledMinutes = [];
            if (date.getHours() === start.getHours()) {
              for (let i = 0; i < start.getMinutes(); i++) {
                disabledMinutes.push(i);
              }
            }
            const disabledSeconds = [];
            if (
              date.getHours() === start.getHours() &&
              date.getMinutes() === start.getMinutes()
            ) {
              for (let i = 0; i < start.getSeconds(); i++) {
                disabledSeconds.push(i);
              }
            }
            return {
              disabledHours: () => disabledHours,
              disabledMinutes: () => disabledMinutes,
              disabledSeconds: () => disabledSeconds,
            };
          },
        };
      },
    },
  },
  methods: {
    openModal(modalId, data) {
      this.deprovision.status_reason = "";
      this.deprovision.status_sub_reason = "";
      this.deprovision.mac = data.mac;
      if (
        data.hasOwnProperty("initial_configuration") &&
        data.initial_configuration != null
      ) {
        this.deprovision.email = data.initial_configuration.activation_email;
      } else {
        this.deprovision.email = "";
      }

      this.showModal = modalId;
    },
    closeModal() {
      this.showModal = null;
    },
    deviceDeactivate() {
      this.closeModal();
      this.is_loading = true;
      /**
       * call state change action api or others id necessary
       */
      this.stateChangeAction();

      /**
       * Deactivate process start
       * @type {default.methods}
       * @private
       */
      if (
        isEmpty(this.deprovision.status_reason) ||
        isEmpty(this.deprovision.status_sub_reason)
      ) {
        this.$toaster.warning("Reason and Sub-Reason required");
        return;
      }
      const _this = this;
      const params = {
        ...this.deprovision,
        userAccountId: LocalStorage.get("accountId"),
      };
      this.is_loading = true;
      axios({
        method: "POST",
        url: _this.reset_api_url + "?accountId=" + LocalStorage.get("accountId"),
        data: params,
        headers: { "Content-Type": "application/json" },
      })
        .then(function (response) {
          _this.$toaster.success(response.data.message);
          _this.reload();
        })
        .catch((errors) => {
          console.log(errors);
          _this.$toaster.error(errors);
        })
        .finally(() => {
          _this.is_loading = false;
          _this.deprovision.status_reason = "";
          _this.deprovision.status_sub_reason = "";
        });
    },
    stateChangeAction() {
      let url = "";
      let action = "";
      for (let i = 0; i < this.pre.provision_states_list.length; i++) {
        const states = this.pre.provision_states_list[i];
        if (
          states.from_state == "De-Activated" &&
          states.to_state == this.deprovision.status_reason &&
          states.to_state_sub == this.deprovision.status_sub_reason
        ) {
          action = states.state_action;
          url = states.state_action_url;
        }
      }
      /**
       * Call action api if and only if action contain @LOCAL tag for local execution
       */
      if (
        action === "GET@LOCAL" ||
        action === "POST@LOCAL" ||
        action === "PUT@LOCAL" ||
        action === "DELETE@LOCAL"
      ) {
        action = action.replaceAll("@LOCAL", "");
        if (
          url !== undefined &&
          url !== null &&
          url !== "" &&
          action !== undefined &&
          action !== null &&
          action !== ""
        ) {
          const params = {
            accountId: LocalStorage.get("accountId"),
          };
          axios({
            method: action,
            url: url,
            data: params,
            headers: { "Content-Type": "application/json" },
          })
            .then(function (response) {
              console.log(response.data.message);
            })
            .catch((errors) => {
              console.log(errors);
            });
        }
      }
    },
    async initialize() {
      this.is_loading = true;

      if ("mac" in this.$route.query) {
        this.filter.mac = this.$route.query.mac;
        this.showFilter = true;
      } else {
        this.filter.mac = "";
      }

      if ("product_name" in this.$route.query) {
        this.filter.product_name = this.$route.query.product_name;
        this.showFilter = true;
      } else {
        this.filter.product_name = "";
      }

      if ("activation_status" in this.$route.query) {
        this.filter.activation_status = this.$route.query.activation_status;

        this.showFilter = true;
      } else {
        this.filter.activation_status = "";
      }

      if ("license_user" in this.$route.query) {
        this.filter.license_user = this.$route.query.license_user;
        this.showFilter = true;
      } else {
        this.filter.license_user = "";
      }
      if ("device_type" in this.$route.query) {
        this.filter.device_type = this.$route.query.device_type;
        this.showFilter = true;
      } else {
        this.filter.device_type = "";
      }

      if ("start_time" in this.$route.query) {
        this.filter.start_time = this.$route.query.start_time;
      } else {
        this.filter.start_time = "";
      }

      if ("end_time" in this.$route.query) {
        this.filter.end_time = this.$route.query.end_time;
      } else {
        this.filter.end_time = "";
      }

      if (_.isEmpty(this.profile)) {
        await CommonAPI.getProfile().then((profile_info) => {
          this.user_detail = profile_info;
        });
      } else {
        this.user_detail = this.profile;
      }

      // await CommonAPI.getCustomPermission(
      //   '/get-custom-permission-infos?path=api/provisions'
      // ).then((response) => {
      //   if (response.status == 200) {
      //     this.custom_permission_data = response.data
      //   }
      // })

      // if (!_.isEmpty(this.custom_permission_data)) {
      //   this.actionCreate = await PermissionChecker.checkCreateButtonPermission(
      //     this.custom_permission_data.action_permission,
      //     this.custom_permission_data['create_id_condition'],
      //     this.user_detail,
      //     this.custom_permission_data.enableAdministratorPermissionByDefault
      //   )
      //   this.actionCreate = true
      // }

      this.getProvisionList()
        .then((response) => {
          this.pre.provision_states_list = response.data;
          const tmp = {};
          for (let i = 0; i < this.pre.provision_states_list.length; i++) {
            const states = this.pre.provision_states_list[i];
            if (states.from_state == "De-Activated") {
              // console.log(states)
              if (!tmp.hasOwnProperty(states.to_state)) {
                tmp[states.to_state] = [];
              }
              tmp[states.to_state].push(states.to_state_sub);
            }
          }
          this.pre.deprovision_reason = tmp;
        })
        .catch((error) => {
          console.error(error);
        });

      await this.getList()
        .then((response) => {
          this.list = response.data;
        })
        .catch((error) => {
          this.empty = true;
          if (error.response.status === 403) {
            this.has_permission = false;
          }
        });

      await this.getAllProduct()
        .then((response) => {
          this.pre.allproduct = response.data;
        })
        .catch((error) => {
          this.pre.allproduct = [];
        });

      await this.getAllDeviceName()
        .then((response) => {
          this.pre.device_name = response.data;
        })
        .catch((error) => {
          this.pre.device_name = [];
        });

      await this.getAllLicenses()
        .then((response) => {
          this.pre.license = response.data;
        })
        .catch((error) => {
          this.pre.license = [];
        });

      await CommonAPI.getAudraName(LocalStorage.get("accountId"))
        .then((response) => {
          this.pre.audraName = response;
        })
        .catch((error) => {
          console.log(error.response);
        });

      this.is_loading = false;
    },
    async getFilterData() {
      this.is_loading = true;
      await this.getList()
        .then((response) => {
          this.list = response.data;
        })
        .catch((error) => {
          this.empty = true;
          if (error.response.status === 403) {
            this.has_permission = false;
          }
        });
      this.$router
        .push({
          path: this.$route.fullPath,
          query: {
            mac: this.filter.mac,
            product_name: this.filter.product_name,
            activation_status: this.filter.activation_status,
            license_user: this.filter.license_user,
            device_type: this.filter.device_type,
            start_time: this.filter.start_time,
            end_time: this.filter.end_time,
          },
        })
        .catch(() => {});
      this.is_loading = false;
    },
    reload: function () {
      this.is_loading = true;
      if ("mac" in this.$route.query) {
        this.filter.mac = this.$route.query.mac;
        this.showFilter = true;
      } else {
        this.filter.mac = "";
      }

      if ("product_name" in this.$route.query) {
        this.filter.product_name = this.$route.query.product_name;
        this.showFilter = true;
      } else {
        this.filter.product_name = "";
      }

      if ("activation_status" in this.$route.query) {
        this.filter.activation_status = this.$route.query.activation_status;

        this.showFilter = true;
      } else {
        this.filter.activation_status = "";
      }

      if ("license_user" in this.$route.query) {
        this.filter.license_user = this.$route.query.license_user;
        this.showFilter = true;
      } else {
        this.filter.license_user = "";
      }
      if ("device_type" in this.$route.query) {
        this.filter.device_type = this.$route.query.device_type;
        this.showFilter = true;
      } else {
        this.filter.device_type = "";
      }

      if ("start_time" in this.$route.query) {
        this.filter.start_time = this.$route.query.start_time;
      } else {
        this.filter.start_time = "";
      }

      if ("end_time" in this.$route.query) {
        this.filter.end_time = this.$route.query.end_time;
      } else {
        this.filter.end_time = "";
      }

      this.getList()
        .then((response) => {
          this.list = response.data;
        })
        .catch((error) => {
          this.empty = true;
          if (error.response.status === 403) {
            this.has_permission = false;
          }
        })
        .finally(() => {
          this.is_loading = false;
        });
    },
    getList: function () {
      return new Promise((resolve, reject) => {
        let params = { page: this.list.current_page };
        params = {
          ...this.filter,
          userAccountId: LocalStorage.get("accountId"),
          ...this.$route.query,
          ...params,
        };
        axios
          .get(this.api_url, {
            params: params,
          })
          .then((response) => {
            resolve(response);
          })
          .catch((error) => {
            reject(error);
            // console.log("error", error.response.data);
          })
          .finally(() => {
            // _this.is_loading = false;
          });
      });
    },
    getProvisionList: function () {
      return new Promise((resolve, reject) => {
        let params = {};
        params = {
          userAccountId: LocalStorage.get("accountId"),
        };
        axios
          .get(this.provision_list_api_url, {
            params: params,
          })
          .then((response) => {
            resolve(response);
          })
          .catch((error) => {
            reject(error);
            // console.log("error", error.response.data);
          })
          .finally(() => {
            // _this.is_loading = false;
          });
      });
    },
    getAllProduct: function () {
      return new Promise((resolve, reject) => {
        let params = {
          userAccountId: LocalStorage.get("accountId"),
          ...this.$route.query,
        };
        axios
          .get("/provision-product", {
            params: params,
          })
          .then((response) => {
            resolve(response);
          })
          .catch((error) => {
            reject(error);
          });
      });
    },
    getAllDeviceName: function () {
      return new Promise((resolve, reject) => {
        let params = {
          userAccountId: LocalStorage.get("accountId"),
          ...this.$route.query,
        };
        axios
          .get("/provision-device-name", {
            params: params,
          })
          .then((response) => {
            resolve(response);
          })
          .catch((error) => {
            reject(error);
          });
      });
    },
    getAllLicenses: function () {
      return new Promise((resolve, reject) => {
        let params = {
          userAccountId: LocalStorage.get("accountId"),
          ...this.$route.query,
        };
        axios
          .get("/provision-license", {
            params: params,
          })
          .then((response) => {
            resolve(response);
          })
          .catch((error) => {
            reject(error);
          });
      });
    },
    getEndDatePickerOptions() {
      return {
        disabledDate: (date) => {
          if (!this.filter.start_time) return false;
          return date.getTime() < new Date(this.filter.start_time).getTime();
        },
      };
    },
    getToStatesList: function (from_states) {
      const to_states = [];
      for (let i = 0; i < this.pre.provision_states_list.length; i++) {
        const states_obj = this.pre.provision_states_list[i];
        if (states_obj.from_state === from_states) {
          const containsToState = to_states.some(
            (obj) => obj.to_state === states_obj.to_state
          );
          if (!containsToState) {
            to_states.push(states_obj);
          }
        }
      }
      return to_states;
    },
    checkEditPermission: function (data) {
      if (!_.isEmpty(this.custom_permission_data)) {
        return PermissionChecker.checkEditButtonPermission(
          this.custom_permission_data.action_permission,
          this.custom_permission_data["edit_id_condition"],
          this.custom_permission_data["edit_refid_condition"],
          this.custom_permission_data["edit_custom_condition"],
          data,
          this.user_detail,
          this.custom_permission_data.enableAdministratorPermissionByDefault
        );
      } else {
        return false;
      }
    },
    checkDeletePermission: function (data) {
      if (!_.isEmpty(this.custom_permission_data)) {
        return PermissionChecker.checkDeleteButtonPermission(
          this.custom_permission_data.action_permission,
          this.custom_permission_data["delete_id_condition"],
          this.custom_permission_data["delete_refid_condition"],
          this.custom_permission_data["delete_custom_condition"],
          data,
          this.user_detail,
          this.custom_permission_data.enableAdministratorPermissionByDefault
        );
      } else {
        return false;
      }
    },
    async resetFilter() {
      this.is_loading = true;
      this.filter = {
        mac: "",
        product_name: "",
        activation_status: "",
        license_user: "",
        device_type: "",
        start_time: "",
        end_time: "",
      };

      this.$router
        .push({
          path: this.$route.path,
          query: {},
        })
        .catch(() => {});
      await this.getList()
        .then((response) => {
          this.list = response.data;
        })
        .catch((error) => {
          this.empty = true;
          if (error.response && error.response.status === 403) {
            this.has_permission = false;
          }
        });
      // this.getList();
      this.is_loading = false;
    },
    deleteObject: function (id, index) {
      const _this = this;
      const delete_api_url = "/provisions/" + id;

      _this.$swal
        .fire({
          title: "Are you sure?",
          text: "You won't be able to revert this!",
          icon: "warning",
          showCancelButton: true,
          confirmButtonColor: "#3085d6",
          cancelButtonColor: "#d33",
          confirmButtonText: "Yes, delete it!",
        })
        .then((result) => {
          if (result.isConfirmed) {
            _this.is_loading = true;
            axios
              .delete(delete_api_url)
              .then((response) => {
                _this.list.data.splice(index, 1);
                _this.list.total -= 1;
                _this.$toaster.success(response.data.message);
                _this.is_loading = false;
              })
              .catch((error) => {
                _this.is_loading = false;
                console.log(error);
                _this.$swal.fire("Failed!", "failed to delete.", "error");
              })
              .finally(() => {
                _this.is_loading = false;
              });
          }
        });
    },
    getNameValue: function (fulRow) {
      if (fulRow.initial_configuration) {
        if (!_.isEmpty(fulRow.initial_configuration.username)) {
          return fulRow.initial_configuration.username;
        }
      }
      return fulRow.name;
    },
    getEmailValue: function (fulRow) {
      if (fulRow.initial_configuration) {
        if (!_.isEmpty(fulRow.initial_configuration.activation_email)) {
          return fulRow.initial_configuration.activation_email;
        }
      }
      return fulRow.email;
    },

    async resendActivationEmail(row) {
      try {
        this.is_loading = true;

        const payload = {
          email: row.account ? row.account.activation_email : null,
          mac: row.mac,
        };

        const { data } = await axios.post("/send-password-reset-email", payload);
        console.log(data);

        this.$toaster.success(data.message);
      } catch (e) {
        console.error(e);
        this.$message.error("Failed to resend email.");
      } finally {
        this.is_loading = false;
      }
    },
  },
};
</script>
<style scoped>
.el-date-editor .el-range-separator {
  width: 6%;
}
.modal {
  z-index: 9999;
}

.modal-body p {
  font-size: 0.9rem;
  line-height: 1.5rem;
}
</style>
